import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ILessonAssetLink } from '@models/lesson-asset-link';
import { LessonAssetLinkLaunchError } from '@models/lesson-asset-link-launch-result';
import { ILessonStep } from '@models/lesson-section';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Options } from '@popperjs/core';
import { ButtonComponent } from '@shared/button/button.component';
import { PreloaderModule } from '@shared/preloader/preloader.module';
import { ControlPopoverComponent } from '@shared/viewer/viewer-controls/control-popover/control-popover.component';
import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'zbp-viewer-lesson-materials',
  imports: [
    ButtonComponent,
    ControlPopoverComponent,
    NgbPopover,
    ZbpIconComponent,
    PreloaderModule
  ],
  templateUrl: './viewer-lesson-materials.component.html',
  styleUrl: './viewer-lesson-materials.component.scss'
})
export class ViewerLessonMaterialsComponent implements AfterViewInit, OnChanges {

  @Input() isDesktop: boolean;
  @Input() lessonSteps: ILessonStep[];

  @ViewChild('popoverControl') popoverControl!: ControlPopoverComponent;

  protected readonly zbpIconNames = zbpIconNames;

  hasLoadedLessonSteps: boolean = false;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lessonSteps && changes.lessonSteps.currentValue) {
      this.hasLoadedLessonSteps = true;
    }
  }

  showPopover() {
    this.popoverControl.onPopoverShown();
  }

  popperOptions(options: Options): Options {
    return {
      ...options,
      strategy: 'absolute',
      modifiers: [
        ...(options.modifiers || []),
        {
          name: 'offset',
          options: {
            offset: [0, 0],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            // Allows popover to stay visible even when scrolled
            padding: 0,
          },
        },
      ],
    };
  }

  getAssetLinkHref(link: ILessonAssetLink): string {
    return link.builtLaunchResult && 'path' in link.builtLaunchResult ? link.builtLaunchResult.path : '#';
  }

  async onAssetLinkClick(event: Event, link: ILessonAssetLink): Promise<void> {
    event.preventDefault()
    if ('error' in link.builtLaunchResult) {
      if (link.builtLaunchResult.error === LessonAssetLinkLaunchError.MaterialNotFound) {
        this.toastr.error('Could not find the corresponding material for this link.');
      } else {
        this.toastr.error('Could not find the product for this link.');
      }
      return;
    }
    if (link.builtIsLocalViewerResult) {
      const url = new URL(link.builtLaunchResult.path);
      await this.router.navigateByUrl(url.pathname.replace(/\/$/, '') + url.search + url.hash);
    } else {
      window.open(link.builtLaunchResult.path, '_blank');
    }
  }
}
